module.exports = __webpack_public_path__ + "static/media/twitter.45227e3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter.svg
// module id = 223
// module chunks = 2